module.exports = __webpack_public_path__ + "assets/img/title-3a6ea52f.png";